var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters } from './_default-imports';
import { TemplateElement } from '../../template';
//namespace Pacem.Components {
let PacemTemplateProxyElement = class PacemTemplateProxyElement extends /*PacemEventTarget*/ /*PacemEventTarget*/ TemplateElement {
    propertyChangedCallback(name, old, val, first) {
        // super.propertyChangedCallback(name, old, val, first);
        if (name === 'target') {
            this.dispatchEvent(new Event('templatechange'));
        }
    }
    addEventListener(type, listener, options) {
        super.addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        super.removeEventListener(type, listener, options);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemTemplateProxyElement.prototype, "target", void 0);
PacemTemplateProxyElement = __decorate([
    CustomElement({ tagName: P + '-template-proxy' })
], PacemTemplateProxyElement);
export { PacemTemplateProxyElement };
//}
